import React, { useMemo } from "react";
import AdminTabelHeader from "../../components/layout/header/AdminTabelHeader";
import { socialMediaData } from "./socialmediaData";
import "./socialmedia.css";

import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { BASEURL } from "../../../utils/BaseUrl";
import axios from "axios";
import { MaterialReactTable } from "material-react-table";
import TraingleLoading from "../../../common/Loading/TraingleLoading";
const SocialMediaAdmin = () => {
  const navigate = useNavigate();

  const { data,isLoading } = useQuery({
    queryKey: "getAllsocial",
    queryFn: () =>
      axios.get(`${BASEURL}social-media`).then((res) => {
        return res?.data;
      }),
  });

  const columns = useMemo(
    () => [
      {
        accessorFn: (row, index) => index + 1,
        id: "index",
        header: "S.No",
        size: 100,
      },

      {
        accessorKey: "platform",
        header: "PlatForm",
      },
      {
        accessorKey: "url",
        header: "Url",
        size: 300,
      },
      {
        id: "status",
        header: "Status",
        Cell: ({ row }) => (
          <div
            className={`font-semibold  py-1 rounded-xl text-white px-4 ${
              row?.original?.status ? "bg-green-700" : "bg-speed-red"
            }`}
          >
            {row?.original?.status ? "Active" : "In Active"}
          </div>
        ),
      },

      {
        id: "actions",
        header: "Actions",
        Cell: ({ row }) => (
          <>
            <div className="flex items-center justify-around">
              <PencilIcon
                onClick={() => navigate(`edit/${row?.original?.id}`)}
                className="w-5 h-5 cursor-pointer mx-2"
              />

            
            </div>
          </>
        ),
      },
    ],
    []
  );
  return (
    <div>
      <AdminTabelHeader title={"Social Media"} btnStatus={false} />
      {
        isLoading && <TraingleLoading />
      }

      <div className="p-4">
        <MaterialReactTable
          columns={columns}
          data={data?.links || []}
          enableColumnResizing
          enableColumnOrdering
        />
      </div>
    </div>
  );
};

export default SocialMediaAdmin;
